<template>
  <div class="member-wrapper">
    <div class='content'>
      <div class="auto-recognition-box">
        <header>
          <span>示例：王XX，136xxxx0000，浙江省杭州市西湖区某小区</span>
        </header>
        <van-field v-model="textarea" rows="3" autosize label="" type="textarea" placeholder="请粘贴或输入文本，点击“识别”按钮自动识别收货人姓名、手机号、地址" />
        <van-uploader class="up-wrapper" :after-read="afterRead" :before-read="beforeRead">
          <van-button plain icon="photo" round type="default" size="mini">照片识别</van-button>
        </van-uploader>
        <div class="btn-wrapper">
          <van-button round :disabled="!textarea" size="mini" @click="getAddressDetail" class='ide-btn'>识别</van-button>
        </div>
      </div>
      <van-cell-group>
        <van-field v-model.trim="params.ReceiveName" required name="receiveName" v-validate="rules.receiveName" :error-message="errors.first('receiveName')" clearable label="收件人" maxlength=50 placeholder="请输入收件人姓名" />
        <van-field v-model="hospitalName" required name="hospitalName" label="医院名称" v-validate="rules.hospitalName" :error-message="errors.first('hospitalName')" @click="modalShow.hospital=true" is-link readonly />
        <van-field v-model.trim="params.Mobile" required clearable name="mobile" v-validate="rules.mobile" :error-message="errors.first('mobile')" label="手机号码" placeholder="请输入收件人手机号码" />
        <van-field v-model.trim="params.Telphone" clearable name="telphone" label="固定电话" v-validate="rules.telphone" :error-message="errors.first('telphone')" placeholder="请输入收件人固定电话" />
        <van-field v-model="showAreaText" required name="location" label="所在地区" v-validate="rules.location" :error-message="errors.first('location')" @click="modalShow.area=true" is-link readonly />
        <van-field v-model="params.TaxPayerNo" :required="addrIsTaiwan" name="tax" label="收件人税号" v-validate="rules.tax" :error-message="errors.first('tax')" v-if="addrIsTaiwan" />
        <van-field v-model.trim="params.Address" name="detailAddress" type='textarea' maxlength=500 required clearable label="详细地址" v-validate="rules.detailAddress" :error-message="errors.first('detailAddress')" placeholder="请输入收件人详细地址" />
        <van-cell title="设为默认地址">
          <van-switch v-model="params.IsDefault" size="24px" />
        </van-cell>
        <van-checkbox v-if="!isSend" v-model="params.IsReplaceAllAddress">替换该医生医院下所有病例的收货地址/所有备货分配前的发货任务的收货地址</van-checkbox>
      </van-cell-group>
      <div class='common-btn-wrap'>
        <van-button type="info" round size="large" @click="save" :disabled="saveDisabled">保存</van-button>
      </div>
      <!--医院-->
      <van-popup v-model="modalShow.hospital" position="bottom">
        <van-picker show-toolbar :columns="optData.hospital" @confirm="changeHospitalOptData" @cancel="closeModal('hospital')" value-key="HospitalName" />
      </van-popup>
      <!--省市区-->
      <van-popup v-model="modalShow.area" position="bottom">
        <div class="select-area-wrap">
          <div class="btn">
            <a class="cancel" @click="closeModal('area')">取消</a>
            <a class="confirm" @click="confirmChoseAreaData">确定</a>
          </div>
          <div class="list-box">
            <van-picker class="area-list" :columns="optData.areaOpt.country" @change="getSubArea" :default-index="choseAreaKey.countryIndex" value-key="Name" />
            <van-picker class="area-list" :columns="optData.areaOpt.province" @change="getSubArea" :default-index="choseAreaKey.provinceIndex" value-key="Name" />
            <van-picker class="area-list" :columns="optData.areaOpt.city" @change="getSubArea" :default-index="choseAreaKey.cityIndex" value-key="Name" />
            <van-picker class="area-list" :columns="optData.areaOpt.area" @change="getSubArea" :default-index="choseAreaKey.areaIndex" value-key="Name" />
          </div>
        </div>
      </van-popup>

    </div>
  </div>
</template>
<script>
import { Toast, Area } from 'vant';
import Cookies from 'js-cookie';
import { GetAliImageUploadPath, newClient } from '@/Api/upload'
import { guid } from '@/utils/guid'
export default {
  data () {
    return {
      textarea: '',
      addressId: this.$route.params.id,//id为空时默认新增,否则为编辑
      isSend: false,
      params: {
        AppID: this.GLOBAL.AppID,
        Method: 'UpdateDoctorReceiveAddressV1',
        ReceiveAddressID: this.$route.params.id || '',
        UserRegisterID: Cookies.get('uid'),//用户编号
        HospitalID: '',//医院编号
        AreaID: '',//地区编号:支持市编号,支持区编号
        ReceiveName: '',//收件人姓名:maxlength:100
        Address: '',//详细地址:maxlength:500
        Mobile: '',//手机:maxlength:11
        IsDefault: false,//是否默认:false:不是默认,true:默认
        Telphone: '',//固话:maxlength:50 
        TaxPayerNo: '',//税号,台湾地区必须输入
        IsReplaceAllAddress: false,//是否替换所有病例的收货地址:false:不是,true:是 
      },
      hospitalName: '',//医院名称,界面展示
      showAreaText: '',//地址,界面展示
      isEdit: false,
      headType: '',
      optData: {//选项数据
        hospital: [],
        areaOpt: {
          country: [],
          province: [],
          city: [],
          area: []
        }
      },
      areaName: {
        1: 'country',
        2: 'province',
        3: 'city',
        4: 'area'
      },
      choseAreaKey: {
        countryIndex: 0,
        provinceIndex: 0,
        cityIndex: 0,
        areaIndex: 0
      },
      rules: {
        receiveName: { required: true },
        hospitalName: { required: true },
        mobile: { required: true, formatMobile: true },
        telphone: { formatTelphone: true },
        location: { required: true },
        detailAddress: { required: true },
        tax: { required: true }
      },
      modalShow: {//选项弹窗
        hospital: false,
        area: false
      },
      resultArea: {},
      areaTemp: true,
      saveDisabled: false,//保存按钮是否可点击,防止重复提交
      addrIsTaiwan: false,//收货地址是否为台湾,台湾时展示税号
      uploadRegion: 'cn-shanghai',//中文版统一为 cn-shanghai
      syncRegion: 'cn-shanghai',//中文版统一为 cn-shanghai
      isAccelerate: false,//中文版统一为false
    }
  },
  mounted () {
    this.getHospital();
    this.validateField();
    //编辑获取详情
    if (this.addressId) {
      this.getDetail();
    } else {
      this.getArea(1, null, false);
    }
  },
  computed: {
    headname () {
      let str = '收货地址'
      if (!this.addressId) {
        this.isEdit = false
        return '新增' + str
      } else {
        this.isEdit = true
        return '编辑' + str
      }
    }
  },

  methods: {
    //获取图片属性信息
    util (file) {
      return new Promise(resolve => {
        let reader = new FileReader();
        reader.onload = function (e) {
          let data = e.target.result;
          let img = new Image();
          // _that.$emit('localAttr', data)
          img.src = data;
          resolve(img);
        };
        reader.readAsDataURL(file);
      });
    },
    beforeRead (file) {
      if (file.type === 'image/jpeg' || file.type === 'image/png') {
        return true;
      }
      Toast('请上传 jpg或png 格式图片');
      return false;
    },
    async afterRead (file) {
      let _that = this
      try {
        let img = await this.util(file.file)
        if (_that.method == '') {
          _that.method = 'FontImage'
        }
        let res = await GetAliImageUploadPath(
          guid.newGUID(),
          file.file.name,
          _that.method,
          img.height,
          img.width,
          file.file.size,
          new Date().getTime(),
          _that.uploadRegion,
          _that.syncRegion,
          _that.isAccelerate
        )
        _that.client = await newClient(res, _that.uploadRegion)
        _that.client.multipartUpload(res.Path, file.file, {
          progress: function (percentage) {
            // 上传进度
            _that.percentageShow = true
            _that.percentage = Number((percentage * 100).toFixed(2))
          }
        }).then(results => {
          let url = results.name
          this.identifyImage(url)
        })
      } catch (e) {
        Toast.fail({
          message: '照片上传失败!',
          duration: '1000'
        })
      }
    },
    async identifyImage (url) {
      let req = {
        AppID: 16,
        Method: 'GetOcrAddressDetail',
        Path: url, // 全地址:maxlength:500 
      }
      let result = await this.$Request(req)
      Toast('识别成功，请检查相应收货信息。')
      this.updateReceiveData(result)
    },
    // 识别详细地址
    async getAddressDetail () {
      try {
        if (this.textarea && this.textarea != '') {
          let req = {
            AppID: 16,
            Method: 'GetAddressDetail',
            FullAddress: this.textarea.trim(), // 全地址:maxlength:500 
          }
          let result = await this.$Request(req)
          Toast('识别成功，请检查相应收货信息。')
          this.updateReceiveData(result)
        }
      } catch (error) { }
    },
    updateReceiveData (result) {
      if (result) {
        // 收货人姓名
        const name = result.UserName.replaceAll('\n')
        if (name) {
          this.params.ReceiveName = name
        }
        // 收货人手机
        const mobile = result.Mobile.replaceAll('\n')
        if (mobile) {
          this.params.Mobile = mobile
        }
        // 收货人电话
        const phone = result.Telephone.replaceAll('\n')
        if (phone) {
          this.params.TelPhone = phone
        }
        // 所在区域
        let countryText = result.CountryName;
        let provinceText = result.ProvinceName;
        let cityText = result.CityName;
        let areaText = result.RegionName;
        areaText = (areaText == 0 ? '' : areaText);
        this.showAreaText = countryText + '' + provinceText + '' + cityText + '' + areaText;
        if (result.RegionID) {
          this.resultArea.CountryID = result.CountryID
          this.resultArea.ProvinceID = result.ProvinceID
          this.resultArea.CityID = result.CityID
          this.resultArea.RegionID = result.RegionID
          this.areaTemp = true
          // this.getArea(4, result.CityID)
          // this.getArea(3, result.ProvinceID)
          this.getArea(2, result.CountryID)
        }
        // 详细地址
        const address = result.Address.replaceAll('\n')
        if (address) {
          this.params.Address = address
        }

      }
    },
    //保存
    save () {
      this.$validator.validateAll().then(result => {
        if (result) {
          Toast.loading({
            duration: 0,
            message: '数据保存中...',
            overlay: true
          });
          this.saveDisabled = true;
          let sendParams = this.params;
          //编辑,传参-方法名更改及增加一个收货地址编号
          if (this.addressId) {
            // sendParams.Method = 'UpdateDoctorReceiveAddressV1';
            delete sendParams.UserRegisterID;
          } else {
            delete sendParams.ReceiveAddressID;
          }
          this.$Request(sendParams).then(res => {
            Toast.clear();
            Toast.success({
              duration: 1000,
              message: '保存成功'
            })
            setTimeout(() => {
              this.saveDisabled = false;
              this.$router.push({ path: '/address-list' })
            }, 1000)
          }, err => {
            setTimeout(() => {
              Toast.clear();
              this.saveDisabled = false;
            }, 3000)
          })
        }
      })
    },
    //验证
    validateField () {
      this.$validator.extend('formatMobile', {
        getMessage: field => "请输入正确的手机号码",
        validate: (value) => {
          return /^1\d{10}$/.test(value)
        }
      });
      this.$validator.extend('formatTelphone', {
        getMessage: field => "请输入正确的固定电话",
        validate: (value) => {
          return /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value)
        }
      });
    },
    //编辑=根据地址获取详情
    getDetail () {
      Toast.loading({
        duration: 0,
        message: '数据加载中...'
      });
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetDoctorReceiveAddress',
        DoctorReceiveAddressID: this.addressId,//收件地址编号 
      }).then(res => {
        Toast.clear();
        let result = res.ReceiveAddressItem || {};
        this.params.HospitalID = result.HospitalItem.HospitalID;
        this.params.AreaID = result.AreaItem.CityID;
        this.params.ReceiveName = result.ReceiveName;
        this.params.Address = result.AreaItem.Address;
        this.params.Mobile = result.Mobile;
        this.params.Telphone = result.Telphone;
        this.params.IsDefault = result.IsDefault;
        this.params.TaxPayerNo = result.TaxPayerNo;
        this.hospitalName = result.HospitalItem.Name;
        this.isSend = result.HospitalItem.IsSend;
        this.resultArea = Object.assign({}, result.AreaItem);
        this.showAreaText = `${result.AreaItem.CountryName}${result.AreaItem.ProvinceName}${result.AreaItem.CityName}${result.AreaItem.RegionName}`;
        this.getArea(1, null, false);
      }, err => {
        Toast.clear();
      })
    },
    //获取医院
    getHospital () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Methods: 'GetCaseHospitals'
      }).then(res => {
        this.optData.hospital = res.UserRegisterHospitalItems || [];
      })
    },
    //获取地区
    getArea (type, AreaID) {
      let subType = type;
      let areaId = AreaID;
      if (subType > 4) {
        return;
      }
      let sendParams = {
        AppID: this.GLOBAL.AppID,
        Method: 'GetAreas',
        AreaID: areaId || '',//地区编号
        Type: type,//地区分类:1:国家,2:省/州,3:市,4:县/区 
      }
      this.$Request(sendParams).then(res => {
        if (res.AreaItems && res.AreaItems.length) {
          if (this.addressId && this.resultArea && this.areaTemp) {
            this.optData.areaOpt[this.areaName[type]] = res.AreaItems;
            this.optData.areaOpt[this.areaName[type]].map((item, index) => {
              if (type === 1 && (item.AreaID === this.resultArea.CountryID)) {
                this.choseAreaKey.countryIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
              }
              if (type === 2 && (item.AreaID === this.resultArea.ProvinceID)) {
                this.choseAreaKey.provinceIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
              }
              if (type === 3 && (item.AreaID === this.resultArea.CityID)) {
                this.choseAreaKey.cityIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                this.addrIsTaiwan = this.optData.areaOpt[this.areaName[type]][index].IsTaiwan;
              }
              if (type === 4 && (item.AreaID === this.resultArea.RegionID)) {
                this.choseAreaKey.areaIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                this.addrIsTaiwan = this.optData.areaOpt[this.areaName[type]][index].IsTaiwan;
              }
            })
            subType = type + 1;
            this.getArea(subType, areaId);
            subType++;
          } else {
            this.optData.areaOpt[this.areaName[type]] = res.AreaItems;
            areaId = this.optData.areaOpt[this.areaName[type]][0].AreaID;
            subType = type + 1;
            this.getArea(subType, areaId);
            subType++;
          }
        } else {
          this.optData.areaOpt[this.areaName[type]] = [];
        }
      })
    },
    getSubArea (picker, value, index) {
      this.areaTemp = false;
      let subLevel = parseInt(value.Type) + 1;
      let AreaID = value.AreaID;
      //   let IsForeign = value.IsForeign;
      if (value.Type == 1) {
        this.choseAreaKey.provinceIndex = 0;
        this.choseAreaKey.cityIndex = 0;
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.countryIndex = index;
      } else if (value.Type == 2) {
        this.choseAreaKey.cityIndex = 0;
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.provinceIndex = index;
      } else if (value.Type == 3) {
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.cityIndex = index;
      } else if (value.Type == 4) {
        this.choseAreaKey.areaIndex = index;
      }
      this.getArea(subLevel, AreaID);
    },
    //选择医院确认操作
    changeHospitalOptData (item) {
      this.hospitalName = item.HospitalName;
      this.params.HospitalID = item.HospitalID;
      this.modalShow.hospital = false;
    },
    //确定选择省市区
    confirmChoseAreaData () {
      let countryText = this.optData.areaOpt.country.length && this.optData.areaOpt.country[this.choseAreaKey.countryIndex].Name;
      let provinceText = this.optData.areaOpt.province.length && this.optData.areaOpt.province[this.choseAreaKey.provinceIndex].Name;
      let cityText = this.optData.areaOpt.city.length && this.optData.areaOpt.city[this.choseAreaKey.cityIndex].Name;
      let areaText = this.optData.areaOpt.area.length && this.optData.areaOpt.area[this.choseAreaKey.areaIndex].Name;
      areaText = (areaText == 0 ? '' : areaText);
      this.showAreaText = countryText + '' + provinceText + '' + cityText + '' + areaText;
      //AreaID取最后一级,如果没有取上级
      if (this.optData.areaOpt.area[this.choseAreaKey.areaIndex]) {
        this.params.AreaID = this.optData.areaOpt.area[this.choseAreaKey.areaIndex].AreaID;
        this.addrIsTaiwan = this.optData.areaOpt.area[this.choseAreaKey.areaIndex].IsTaiwan;
      } else {
        this.params.AreaID = this.optData.areaOpt.city[this.choseAreaKey.cityIndex].AreaID;
        this.addrIsTaiwan = this.optData.areaOpt.city[this.choseAreaKey.areaIndex].IsTaiwan;
      }
      if (!this.addrIsTaiwan) {
        this.params.TaxPayerNo = "";
      }
      this.closeModal('area');
    },
    //关闭选项弹窗
    closeModal (field) {
      this.modalShow[field] = false;
    }
  },
  components: {
    Toast
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 20px 10px;
  .common-btn-wrap {
    position: absolute;
    bottom: 200px;
  }
}

.select-area-wrap {
  .btn {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #eeeeee;
    a {
      color: @blue;
    }
  }
  .list-box {
    display: flex;
    justify-content: space-around;
    padding-bottom: 20px;
  }
  .area-list {
    width: 25%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/edit-address.vue